import { appUrls } from "../EasyProjectsCommon/AppUrls";

export const getBrandName = () => (ep.settings.isBirdviewBrand ? "Birdview" : "Easy Projects");
export const isBirdViewBrand = (): boolean => ep.settings.isBirdviewBrand;

export type BrandLinksNames = keyof typeof appUrls.birdview & keyof typeof appUrls.easyprojects;

export const getLinkForBrandByName = (linkName: BrandLinksNames): string =>
    ep.settings.isBirdviewBrand ? appUrls.birdview?.[linkName] : appUrls.easyprojects?.[linkName];

export const brandNameKey = "{brandName}";

export const getResxWithBrandName = (resx: string) =>
    resx?.replace(new RegExp(`${brandNameKey}`, "gi"), getBrandName());
